import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";

export default function ContactForm() {
  const toast = useRef(null);
  const recaptchaRef = useRef(null);

  const [form, setForm] = useState({
    fullName: "",
    businessEmail: "",
    phone: "",
    message: ""
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const blockedDomains = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "hotmail.com",
    "icloud.com",
    "aol.com"
  ];

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
  };

  const validate = () => {
    let newErrors = {};

    if (!form.fullName.trim())
      newErrors.fullName = "Full Name is required";

    if (!form.businessEmail) {
      newErrors.businessEmail = "Business Email is required";
    } else {
      const parts = form.businessEmail.split("@");
      if (parts.length !== 2) {
        newErrors.businessEmail = "Invalid Email format";
      } else if (blockedDomains.includes(parts[1].toLowerCase())) {
        newErrors.businessEmail = "Please use a business email address";
      }
    }


    if (!form.message.trim())
      newErrors.message = "Message is required";

    if (!captchaValue)
      newErrors.captcha = "Please verify captcha";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);

    try {
    const adminPromise =  emailjs.send(
  "service_91ah5pa", // Service Id (Email Verification)
  "template_xfvktvh", // Template Id  Service Id (Email Verification)
  { 
    ...form,
    "g-recaptcha-response": captchaValue
  },
  "KjQBI4zTjEjIVN5Q8" // Public Key  Service Id (Email Verification)
);
const userPromise = emailjs.send(
    "service_glfodzd", // Your Auto-reply Service ID
    "template_viq4b9w",  // Your Auto-reply Template ID
    {
      ...form, 
    user_email: form.businessEmail, 
   

    },
    "KjQBI4zTjEjIVN5Q8" // Public Key  Service Id (Email Verification)
  );
  await Promise.all([adminPromise, userPromise]);
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Message sent successfully!",
        life: 3000
      });

      setForm({
        fullName: "",
        businessEmail: "",
        phone: "",
        message: ""
      });

      recaptchaRef.current.reset();
      setCaptchaValue(null);
      setErrors({});
    } catch (error) {
      console.error(error);

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to send message. Please try again.",
        life: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-fluid shadow-4"
      style={{ maxWidth: "500px",  padding: "20px" }}>
      
      <Toast ref={toast} />
      <h3 className="text-center mb-4">Business Contact Form</h3>

      <div className="field mb-3">
        <label htmlFor="fullName">Full Name *</label>
        <InputText
        placeholder="John Doe"
          id="fullName"
          value={form.fullName}
          onChange={handleChange}
          className={errors.fullName ? "p-invalid" : ""}
        />
        {errors.fullName && <small className="p-error">{errors.fullName}</small>}
      </div>

      <div className="field mb-3">
        <label htmlFor="businessEmail">Business Email *</label>
        <InputText
          id="businessEmail"
          type="email"
          placeholder="You@Company.Domain"
          value={form.businessEmail}
          onChange={handleChange}
          className={errors.businessEmail ? "p-invalid" : ""}
        />
        {errors.businessEmail && (
          <small className="p-error">{errors.businessEmail}</small>
        )}
      </div>

      <div className="field mb-3">
        <label htmlFor="phone">Phone Number *</label>
        <InputText
          id="phone"
           placeholder="+1 234 567 8900 (Optional) "
          value={form.phone}
          onChange={handleChange}
          className={errors.phone ? "p-invalid" : ""}
        />
        {errors.phone && <small className="p-error">{errors.phone}</small>}
      </div>

      <div className="field mb-3">
        <label htmlFor="message">Message *</label>
        <InputTextarea
          id="message"
          placeholder="Your Message"
          rows={4}
          value={form.message}
          onChange={handleChange}
          className={errors.message ? "p-invalid" : ""}
        />
        {errors.message && <small className="p-error">{errors.message}</small>}
      </div>

     <div className="mb-3">
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6LcoOWssAAAAAIs7P8seueCQ53PY5D_uaC-RfKfq" // Captcha Site Key 
          onChange={(value) => setCaptchaValue(value)}
        />
        {errors.captcha && (
          <small className="p-error">{errors.captcha}</small>
        )}
      </div> 

      <Button
        label={loading ? "Sending..." : "Send Message"}
        icon="pi pi-send"
        loading={loading}
        disabled={loading}
        className="contact-submit-btn"

        onClick={handleSubmit}
      />
    </div>
  );
}
